import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [business] = useParameter<number>("@business-units");
  const [calendar] = useParameter<number>("@calendar");
  const [e_commodities] = useParameter<number[]>("@e_commodities");
  const [e_countries] = useParameter<number[]>("@e_countries");

  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [commoditiesGroup, setCommoditiesGroup] = useParameter<number[]>("@commodities_groups");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@business-units": business,
      "@commodities": commodities,
      "@commodities_groups": commoditiesGroup,
      "@calendar": calendar,
      "@e_calendar": [-1, 0].map((x) => (calendar || 0) + x * 10000).map(String),
      "@e_commodities": e_commodities,
      "@e_countries": e_countries,
    });
  }, [title, subtitle, e_commodities, commoditiesGroup, calendar, commodities, e_countries, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setCommodities((parameters["@commodities"].value as string[]).map(Number));
      setCommoditiesGroup((parameters["@commodities_groups"].value as string[]).map(Number));
    },
    [setCommodities, setCommoditiesGroup]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
